/* global AdditionalPosterCurrentHover, AdditionalPosterSimplifiedHover, AppDownloadPromptEnabled, CarouselV2, CountdownBannerEnabled, DisableRedirect, Epgv2Enabled, EpgSearchEnabled, FNCv2Enabled, LiveTileV2, MVPDDeeplinkEnabled, PreviewPassEnabled, SecondScreenProfileEnabled, ThumbnailNetworkLogoEnabled, AutoplayEnabled, NationDigitalChannel, NationUngatedCTA, CCPAOptOutEnabled, HeroCarouselEnabled, SeriesAnonymousEnabled, SeriesDetailV2Enabled, StrikeBannerEnabled, MvpdSSO, EmailCaptureEnabled, ImmersiveShowcase, RoadblockEnabled, WatchV2Enabled, UpNextLiveEventsEnabled */

import _ from 'lodash';
import { DEVICE_TYPE } from 'helpers/auth.clientless';
import { getCookie, setCookie, removeCookie } from 'helpers/Storage';
import {
  CCPA_DO_NOT_SELL_CHECKED,
  CCPA_DO_NOT_SELL_NOT_SEEN,
  CCPA_DO_NOT_SELL_SEEN,
  DEBUG_PANEL_AD_DEBUG,
  DEBUG_PANEL_AD_SITE_SECTION,
  DEBUG_PANEL_BLACKOUT_FETCH_INTERVAL,
  DEBUG_PANEL_FLAG_ADDITIONAL_POSTER_CURRENT_HOVER,
  DEBUG_PANEL_FLAG_ADDITIONAL_POSTER_SIMPLIFIED_HOVER,
  DEBUG_PANEL_FLAG_CCPA_OPT_OUT,
  DEBUG_PANEL_FLAG_NATION_DIGITAL_CHANNEL,
  DEBUG_PANEL_FLAG_NATION_UNGATED_CTA,
  DEBUG_PANEL_FLAG_STRIKE_BANNER,
  DEBUG_PANEL_LOCATION_COOKIE_DURATION,
  DEBUG_PANEL_USER,
  getPrivacyParameterCookie,
  NATION_ENTITLED_COOKIE_NAME,
  setPrivacyParameterCookie,
} from 'helpers/ContentHelper';
import { toBoolean } from 'helpers/GlobalHelper';
import { getDomain, getUrlParamsFromHash } from 'helpers/RouteHelper';
import { getCookie as getCanIAutoplayCookie } from 'components/CanIAutoplay/Helper';
import { FREEMIUM_EXPERIENCE } from 'index/FreemiumProvider';

let nationDigitalCookie = null;
export const nationDigitalChannelEnabled = () => {
  if (nationDigitalCookie === null) {
    nationDigitalCookie = getCookie({ name: DEBUG_PANEL_FLAG_NATION_DIGITAL_CHANNEL });
  }
  const hasCookie = nationDigitalCookie !== undefined;
  if (hasCookie) return toBoolean(nationDigitalCookie);
  return NationDigitalChannel;
};

let nationUngatedCTA = null;
export const nationUngatedCTAEnabled = () => {
  if (nationUngatedCTA === null) {
    nationUngatedCTA = getCookie({ name: DEBUG_PANEL_FLAG_NATION_UNGATED_CTA });
  }
  const hasCookie = nationUngatedCTA !== undefined;
  if (hasCookie) return toBoolean(nationUngatedCTA);
  return NationUngatedCTA;
};

let ccpaOptOutCookie = null;
export const ccpaOptOutEnabled = () => {
  if (ccpaOptOutCookie === null) {
    ccpaOptOutCookie = getCookie({ name: DEBUG_PANEL_FLAG_CCPA_OPT_OUT });
  }
  if (ccpaOptOutCookie !== undefined) return toBoolean(ccpaOptOutCookie);
  return CCPAOptOutEnabled;
};

let freemiumCookie = null;
export const freemiumCookieEnabled = () => {
  if (freemiumCookie === null) {
    freemiumCookie = getCookie({ name: FREEMIUM_EXPERIENCE });
  }
  return freemiumCookie !== undefined;
};

export const tveEnabled = () => true;

export const appDownloadPromptEnabled = () => AppDownloadPromptEnabled;

function cookieCheck({ cookieName, feature, isGlobalSetTrue }) {
  const cookie = getCookie({ name: cookieName });
  function checkCookie() {
    if (isGlobalSetTrue) return isGlobalSetTrue;
    if (cookie === undefined) {
      return feature;
    }
    return toBoolean(cookie);
  }
  return checkCookie;
}

export const autoplayEnabled = getCanIAutoplayCookie()
  ? cookieCheck({
      cookieName: 'DEBUG_PANEL_FLAG_GLOBAL_PLAYER_AUTOPLAY',
      feature: AutoplayEnabled,
    })
  : () => false;

export const blackoutEnabled = cookieCheck({
  cookieName: 'DEBUG_PANEL_FLAG_BLACKOUT',
  feature: null,
});

export const countdownBannerEnabled = cookieCheck({
  cookieName: 'DEBUG_PANEL_FLAG_COUNTDOWN_BANNER',
  feature: CountdownBannerEnabled,
});

export const secondScreenProfileEnabled = cookieCheck({
  cookieName: 'DEBUG_PANEL_FLAG_SECOND_SCREEN_PROFILE',
  feature: SecondScreenProfileEnabled,
});

export const emailCaptureEnabled = cookieCheck({
  cookieName: 'DEBUG_PANEL_EMAIL_CAPTURE',
  feature: EmailCaptureEnabled,
});

export const mobileWebRoadblockEnabled = cookieCheck({
  cookieName: 'DEBUG_PANEL_FLAG_MOBILE_WEB_ROADBLOCK',
  feature: RoadblockEnabled,
});

export const watchV2Enabled = cookieCheck({
  cookieName: 'DEBUG_PANEL_FLAG_WATCH_V2',
  feature: WatchV2Enabled,
});

export const upNextLiveEventsEnabled = cookieCheck({
  cookieName: 'DEBUG_PANEL_FLAG_UPNEXT_LIVE_EVENTS',
  feature: UpNextLiveEventsEnabled,
});

let currentPosterHoverEnabledCookie = null;
export const currentPosterHoverEnabled = () => {
  const isGlobalSetTrue = window?.additionalPosterCurrentHoverEnabled ?? false;
  if (isGlobalSetTrue) return true;
  if (currentPosterHoverEnabledCookie === null) {
    currentPosterHoverEnabledCookie = getCookie({
      name: DEBUG_PANEL_FLAG_ADDITIONAL_POSTER_CURRENT_HOVER,
    });
  }
  if (currentPosterHoverEnabledCookie === undefined) return AdditionalPosterCurrentHover;
  return toBoolean(currentPosterHoverEnabledCookie);
};

let simplifiedPosterHoverEnabledCookie = null;
export const simplifiedPosterHoverEnabled = () => {
  const isGlobalSetTrue = window?.additionalPosterSimplifiedHoverEnabled ?? false;
  if (isGlobalSetTrue) return true;
  if (simplifiedPosterHoverEnabledCookie === null) {
    simplifiedPosterHoverEnabledCookie = getCookie({
      name: DEBUG_PANEL_FLAG_ADDITIONAL_POSTER_SIMPLIFIED_HOVER,
    });
  }
  if (simplifiedPosterHoverEnabledCookie === undefined) return AdditionalPosterSimplifiedHover;
  return toBoolean(simplifiedPosterHoverEnabledCookie);
};

export const additionalPosterEnabled = () =>
  currentPosterHoverEnabled() || simplifiedPosterHoverEnabled();

export const getBlackoutConfig = () => {
  const externalBlackoutConfig = _.get(window.ExternalConfig, 'blackout');
  const blackoutEnabledOverride = blackoutEnabled();
  const blackoutConfig = { ...externalBlackoutConfig };

  if (blackoutEnabledOverride !== null && externalBlackoutConfig) {
    blackoutConfig.enabled = blackoutEnabledOverride;
  }

  return blackoutConfig;
};

export const blackoutDurationOverride = () => {
  const cookie = getCookie({ name: DEBUG_PANEL_BLACKOUT_FETCH_INTERVAL });
  if (cookie === undefined) return null;
  return _.toInteger(cookie);
};

// Keeping buythroughEnabled for analytics calls.
export const buythroughEnabled = () => false; // eslint-disable-line

let nationEntitledCookie = null;
export const isNationEntitled = () => {
  if (nationEntitledCookie === null) {
    nationEntitledCookie = getCookie({ name: NATION_ENTITLED_COOKIE_NAME });
  }
  return nationEntitledCookie;
};

export const thumbnailNetworkLogoEnabled = () => ThumbnailNetworkLogoEnabled;

export const getAuthNetworksConfig = () => _.get(window.ExternalConfig, 'auth.networks');
const getUserOverrides = () => {
  const cookie = getCookie({ name: DEBUG_PANEL_USER });
  return cookie;
};
export const getDeviceIdOverride = () => _.get(getUserOverrides(), 'deviceId', null);

export const geolocationEnabled = () =>
  toBoolean(_.get(window.ExternalConfig, 'locationGate.enabled'));

export const DEBUG_PANEL_MIN_SEARCH_LENGTH = 'DEBUG_PANEL_MIN_SEARCH_LENGTH';

export const getMinSearchLength = () => {
  const cookie = _.toNumber(getCookie({ name: DEBUG_PANEL_MIN_SEARCH_LENGTH }));
  if (_.isNaN(cookie)) {
    return 1;
  }
  return cookie;
};

export const setMinSearchLength = value => {
  const domain = getFormattedDomain();
  const options = { domain, path: '/' };
  if (!_.isNaN(value)) {
    setCookie({ name: DEBUG_PANEL_MIN_SEARCH_LENGTH, value, options });
  } else {
    removeCookie({ name: DEBUG_PANEL_MIN_SEARCH_LENGTH, options });
  }
};

export const previewModeEnabled = cookieCheck({
  cookieName: 'DEBUG_PANEL_FLAG_PREVIEW_MODE',
  feature: false,
});

export const previewPassEnabled = tveEnabled()
  ? cookieCheck({ cookieName: 'DEBUG_PANEL_FLAG_PREVIEW_PASS', feature: PreviewPassEnabled })
  : () => false;

export const previewPass60MinDisabled = tveEnabled()
  ? cookieCheck({
      cookieName: 'DEBUG_PANEL_FLAG_PREVIEW_PASS_60_MIN',
      feature: false,
    })
  : () => false;

export const mvpdDeeplinkEnabled = cookieCheck({
  cookieName: 'DEBUG_PANEL_FLAG_MVPD_DEEPLINK',
  feature: MVPDDeeplinkEnabled,
});

export const marineAPIKeyEnabled = cookieCheck({
  cookieName: 'DEBUG_PANEL_FLAG_USE_MARINE_API_KEY',
  feature: false,
});

export const getLastKnownProfileId = () => getCookie({ name: 'lastKnownProfileId' });

export const getLastAnonymousProfileId = () => getCookie({ name: 'lastAnonymousProfileId' });

export const getRequestorId = () => _.get(window.ExternalConfig, 'requestorId');

export const getAuthEndpointConfig = () => _.get(window.ExternalConfig, 'api.auth', {});

export const getDeviceType = () => DEVICE_TYPE;

export const getThumbnailBug = () => _.get(window.ExternalConfig, 'upsellPromo.thumbnailBug', {});

export const getPreviewPassImage = () =>
  _.get(window.ExternalConfig, 'auth.previewPass.image', null);

export const getPreviewPassWelcomeDelay = () =>
  _.get(window.ExternalConfig, 'auth.previewPass.welcomeOverlayDelay', 0);

export const getFormattedDomain = () => {
  const domain = getDomain();
  if (!domain) return null;
  return `.${domain}`;
};

export const setDebugCookie = ({ name, value }) => {
  const domain = getFormattedDomain();
  const options = { domain, path: '/' };
  setCookie({ name, value, options });
};

export const setDebugFromUrl = hash => {
  const params = getUrlParamsFromHash(hash);
  const adDebug = _.get(params, 'adzone');
  const adSiteSection = _.get(params, 'adSiteSection');
  if (adDebug) setDebugCookie({ name: DEBUG_PANEL_AD_DEBUG, value: adDebug });
  if (adSiteSection) setDebugCookie({ name: DEBUG_PANEL_AD_SITE_SECTION, value: adSiteSection });
};

export const setOptOutCCPACookie = () => {
  const options = { path: '/' };
  if (ccpaOptOutEnabled()) {
    const isOptedOutCCPA = getPrivacyParameterCookie() === CCPA_DO_NOT_SELL_CHECKED;
    const isOptedOutSeenCCPA = getPrivacyParameterCookie() === CCPA_DO_NOT_SELL_SEEN;

    if (!isOptedOutCCPA && !isOptedOutSeenCCPA) {
      setPrivacyParameterCookie({ value: CCPA_DO_NOT_SELL_NOT_SEEN, options });
    } else if (isOptedOutCCPA) {
      setPrivacyParameterCookie({ value: CCPA_DO_NOT_SELL_CHECKED, options });
    } else if (isOptedOutSeenCCPA) {
      setPrivacyParameterCookie({ value: CCPA_DO_NOT_SELL_SEEN, options });
    }
  }
};

export const getLocationCookieDuration = () => {
  const locationCookieOverride = getCookie({ name: DEBUG_PANEL_LOCATION_COOKIE_DURATION });
  const configCookieDuration = window?.ExternalConfig?.geolocation?.promptIntervalDays ?? 14;
  const durationInDays = locationCookieOverride || configCookieDuration;
  return 3600 * 1000 * 24 * durationInDays;
};

export const getAuthBackgroundImage = () => window?.ExternalConfig?.auth?.backgroundImage ?? null;

export const getAuthSignInBackgroundImage = () =>
  window?.ExternalConfig?.auth?.signInBackgroundImage ?? null;

export const getBadgeConfig = () => window?.ExternalConfig?.badges ?? {};

export const heroCarouselEnabled = cookieCheck({
  cookieName: 'DEBUG_PANEL_FLAG_HERO_CAROUSEL',
  feature: HeroCarouselEnabled,
});

export const isFNCv2Enabled = cookieCheck({
  cookieName: 'DEBUG_PANEL_FLAG_FNCV2',
  feature: FNCv2Enabled,
});

export const isEpgv2Enabled = cookieCheck({
  cookieName: 'DEBUG_PANEL_FLAG_EPGV2',
  feature: Epgv2Enabled,
});

export const isEpgSearchEnabled = cookieCheck({
  cookieName: 'DEBUG_PANEL_FLAG_EPG_SEARCH',
  feature: EpgSearchEnabled,
});

export const isRedirectDisabled = cookieCheck({
  cookieName: 'DEBUG_PANEL_FLAG_DISABLE_REDIRECT',
  feature: DisableRedirect,
});

export const isMVPDSSOEnabled = cookieCheck({
  cookieName: 'DEBUG_PANEL_FLAG_MVPD_SSO',
  feature: MvpdSSO,
});

export const seriesAnonymousEnabled = cookieCheck({
  cookieName: 'DEBUG_PANEL_FLAG_SERIES_ANONYMOUS',
  feature: SeriesAnonymousEnabled,
});

export const seriesV2Enabled = cookieCheck({
  cookieName: 'DEBUG_PANEL_FLAG_SERIES_V2',
  feature: SeriesDetailV2Enabled,
});

export const liveTileCollectionV2Enabled = cookieCheck({
  cookieName: 'DEBUG_PANEL_FLAG_TILE_LIVE_TILE_V2',
  feature: LiveTileV2,
});

export const carouselV2Enabled = cookieCheck({
  cookieName: 'DEBUG_PANEL_FLAG_CAROUSEL_V2',
  feature: CarouselV2,
});

export const immersiveShowcaseEnabled = cookieCheck({
  cookieName: 'DEBUG_PANEL_FLAG_IMMERSIVE_SHOWCASE',
  feature: ImmersiveShowcase,
});

export const strikeBannerEnabled = () => {
  const cookie = getCookie({ name: DEBUG_PANEL_FLAG_STRIKE_BANNER });
  const hasCookie = cookie !== undefined;
  if (hasCookie) return toBoolean(cookie);
  if (window.StrikeBannerEnabled !== undefined) return toBoolean(window.StrikeBannerEnabled);
  return StrikeBannerEnabled;
};
